import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';

const BusinessesContent = lazy(() => import('../../components/Pages/Businesses'));

export default function Businesses(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Businesses page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <BusinessesContent />
      </Suspense>
    </Layout>
  );
}
